import React from 'react';
import '../styles/footer.css';
import { FaWhatsapp,  FaLinkedin, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="name-wrapper">
        <div className="name-container">
          {Array.from({ length: 20 }, (_, i) => (
            <span key={i}>KOSAL KANAKIA</span>
          ))}
        </div>
      </div>

      <div className="say-hi">
        <a href="mailto:kosal.kanakia@gmail.com" className="say-hi-button">Say Hi</a>
      </div>

      <div className="footer-links">
      
        <a href="https://wa.me/919930997409?text=Hi%20Kosal%2C%20I%20saw%20your%20portfolio%20and%20wanted%20to%20connect." target="_blank" rel="noopener noreferrer " className="footer-icon">

          <FaWhatsapp />
        </a>
        {/* <a href="https://twitter.com/yourhandle" target="_blank" rel="noopener noreferrer" className="footer-icon">
          <FaTwitter />
        </a> */}
        <a href="https://linkedin.com/in/kosal-kanakia-b0aa52186" target="_blank" rel="noopener noreferrer" className="footer-icon">
        
          <FaLinkedin />
        </a>
        <a href="mailto:kosal.kanakia@gmail.com" className="footer-icon">
          <FaEnvelope />
        </a>
      </div>


     
      <p>©1983  All Rights Reserved</p>
    </footer>
  );
};

export default Footer;
